import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Book from "@/pages/Book";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Invoice from "@/pages/Invoice";
import PaymentSuccess from "@/pages/PaymentSuccess";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children, hideChrome }) {
  return (
    <div className="App">
      {!hideChrome && <Nav />}
      <main>{children}</main>
      {!hideChrome && <Footer />}
      {!hideChrome && <ChatWidget />}
    </div>
  );
}

function AppShell() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/services" element={<Layout><Services /></Layout>} />
        <Route path="/book" element={<Layout><Book /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route path="/admin" element={<Layout><Admin /></Layout>} />
        <Route path="/invoice/:id" element={<Layout><Invoice /></Layout>} />
        <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
    </>
  );
}

function NotFound() {
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      <div className="text-mono-label">404</div>
      <h1 className="mt-4 font-display font-black text-5xl tracking-tighter">Page not found.</h1>
      <a href="/" className="btn-outline mt-8 inline-block">Back home</a>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </AuthProvider>
  );
}
